import { Box, Button } from '@mui/material'
import { Item } from '../../../common/snippets'
import DropDownOA from '../../../common/dropDownOA'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import { navigation3 } from '../../../common/helper'
import useToken from '../../../helpers/useTokens'
import { RouteMasterHeaders, RouteMasterHeaFilterHeaders, routeZones, statusList } from './constants'
import { useEffect, useState } from 'react'
import { TableComponent } from '../../../common/TableComponent'
import { API_CACHE_DURATION, urls } from '../../../common/constants'
import { GetRequest, PostRequestCachedV3 } from '../../../common/api'
import { useAtom, useSetAtom } from 'jotai'
import { alertAtom, globalLoaderAtom, modalAtom } from '../../../common/jotaiState/globalStateAtoms'
import { AddEditRouteModal } from './addEditRouteModal'
import { Checkbox } from '@mui/material'
import { useTranslation } from '../../../../i18n/I18nProvider'

export const RouteMaster = () => {
  const { translations, language } = useTranslation()
  const gs = translations?.generalSettings || {}
  const tr = (key, fallback) => gs?.[key] || fallback
  const setLoader = useSetAtom(globalLoaderAtom)
  const setAlert = useSetAtom(alertAtom)
  const [modal, setModal] = useAtom(modalAtom)
  const [selectedItem, setSelectedItem] = useState(null)

  const {
    loginData: { strCompanyName, intCompanyID },
  } = useToken()
  const translatedRouteZones = routeZones.map((z) => ({ ...z, name: tr(z.translationKey, z.name) }))
  const translatedStatusList = statusList.map((s) => ({ ...s, name: tr(s.translationKey, s.name) }))
  const headers = RouteMasterHeaders.map((col) => ({
    ...col,
    header: tr(col.translationKey, col.header),
    align: col.align ?? (col.xlCol?.dataType === 'quantity' ? 'right' : 'left'),
    exportHead: tr(col.translationKey, col.header),
  }))
  const criteriaHeaders = RouteMasterHeaFilterHeaders.map((col) => ({
    ...col,
    header: tr(col.translationKey, col.header),
  }))
  const [cityList, setCityList] = useState([])

  const [selectedCity, setSelectedCity] = useState('')
  const [selectedRouteZone, setSelectedRouteZone] = useState('')
  const [selectedStatus, setSelectedStatus] = useState('')
  const [tableData, setTableData] = useState([])
  const reportName = tr('routeMaster', 'Route Master')
  const filterData = {
    dataType: 'entry',
    company: strCompanyName,
    selCity: selectedCity?.CityName || '',
    routeZone: selectedRouteZone?.name || '',
    Status: selectedStatus?.name || '',
  }
  const formatData = (list) => {
    return list.map((item, index) => ({
      ...item,
      SN: index + 1,
      dataType: 'entry',
      Status: item.IsActive === 1 ? tr('gsActive', 'Active') : tr('gsInactive', 'Inactive'),
      Status_view: <Checkbox onChange={(e) => e.preventDefault()} checked={item.IsActive === 1} />,
      Edit: <Button onClick={() => handleEdit(item)}>{tr('gsEdit', 'Edit')}</Button>,
    }))
  }
  const handleEdit = (item) => {
    setSelectedItem(item)
    setModal('editModal')
  }
  useEffect(() => {
    setSelectedStatus((prev) =>
      prev?.id != null
        ? translatedStatusList.find((item) => item.id === prev.id) || prev
        : prev
    )
    setSelectedRouteZone((prev) =>
      prev?.id != null
        ? translatedRouteZones.find((item) => item.id === prev.id) || prev
        : prev
    )
  }, [translations])
  const handleLoad = () => {
    const data = {
      CompanyID: intCompanyID,
      CityID: selectedCity?.CityID || 0,
      RouteZoneID: selectedRouteZone?.id || 0,
      IsActive: selectedStatus?.id || 2,
    }
    GetRequest(urls.getCargoRoutes, data)
      .then((res) => {
        if (res.status !== 'Success') {
          setTableData([])
          throw new Error(res?.ErrMessage || tr('requestFailed', 'Request Failed'))
        }
        if (!Array.isArray(res.Data.Table) || res.Data.Table.length === 0) {
          setTableData([])
          throw new Error(tr('noDataFound', 'No Data Found'))
        }
        setTableData(formatData(res.Data.Table))
      })
      .catch((err) => {
        setAlert({ show: true, msg: err.message, nextId: '' })
      })
      .finally(() => setLoader(false))
  }
  const getCityList = () => {
    const data = {
      intCompanyID,
      intBranchID: 0,
      intUserID: 0,
    }
    PostRequestCachedV3(urls.getCompCityList, data, true, API_CACHE_DURATION)
      .then((res) => {
        if (res.status !== 'Success') {
          throw new Error(res?.ErrMessage || tr('requestFailed', 'Request Failed'))
        }
        if (!Array.isArray(res.Data) || res.Data.length === 0) {
          throw new Error(tr('noDataFound', 'No Data Found'))
        }
        setCityList(res.Data)
      })
      .catch((err) => {
        setAlert({ show: true, msg: err.message, nextId: '' })
      })
      .finally(() => setLoader(false))
  }
  useEffect(() => {
    getCityList()
  }, [])
  return (
    <>
      <Box sx={{ display: 'flex', justifyContent: 'start', alignItems: 'center', margin: '10px 16px' }}>
        <Box sx={{ display: 'flex', gap: '12px' }} className="itemButtons">
          <Item sx={sx.itemsx}>
            <DropDownOA
              id={'selectCompany'}
              label={tr('selectCompany', 'Select Company')}
              defaultvalue={strCompanyName}
              disabled={true}
              minWidth="250px"
              width="220px"
            />
          </Item>
          <Item sx={sx.itemsx} className="disabled-wrapper">
            <Button variant="contained" disabled={true} style={{ ...sx.fullHeight, ...sx.novp }} className="btn btn-primary">
              {tr('goUpper', 'GO')}
            </Button>
          </Item>
          <Item sx={sx.itemsx}>
            <DropDownOA
              id={'city-select'}
              label={tr('selectCity', 'Select City')}
              data={cityList}
              defaultvalue={''}
              idKey={`CityID`}
              dataKey={`CityName`}
              onSelect={(val) => {
                setSelectedCity(val)
              }}
              searchPlaceholder={``}
              width="200px"
              nextId={`route-zone`}
              prevId={``}
            />
          </Item>
          <Item sx={sx.itemsx}>
            <DropDownOA
              key={`route-zone-${language}-${selectedRouteZone?.id ?? 'empty'}`}
              id={'route-zone'}
              label={tr('rmRouteZone', 'Route Zone')}
              data={translatedRouteZones}
              defaultvalue={selectedRouteZone?.name || ''}
              value={selectedRouteZone?.name || ''}
              idKey={`id`}
              dataKey={`name`}
              onSelect={(val) => {
                setSelectedRouteZone(val)
              }}
              searchPlaceholder={``}
              width="200px"
              nextId={`status`}
              prevId={`city-select`}
            />
          </Item>
          <Item sx={sx.itemsx}>
            <DropDownOA
              key={`status-${language}-${selectedStatus?.id ?? 'empty'}`}
              id={'status'}
              label={tr('gsStatus', 'Status')}
              data={translatedStatusList}
              defaultvalue={selectedStatus?.name || ''}
              value={selectedStatus?.name || ''}
              idKey={`id`}
              dataKey={`name`}
              onSelect={(val) => {
                setSelectedStatus(val)
              }}
              searchPlaceholder={``}
              width="200px"
              nextId={`LoadBtn`}
              prevId={`route-zone`}
            />
          </Item>
          <Item sx={{ ...sx.itemsx }} className="disabled-wrapper">
            <Button
              variant="contained"
              id="LoadBtn"
              sx={{ paddingY: '7px !important', height: '36px' }}
              className="btn btn-primary"
              onClick={handleLoad}
              onKeyDown={(e) => navigation3(e, 'newAddBtn', 'Hamali_Type', () => {})}
            >
              {tr('load', 'Load')}
            </Button>
          </Item>
          <Item sx={{ ...sx.itemsx }} className="disabled-wrapper">
            <Button
              variant="outlined"
              id="newAddBtn"
              sx={{ width: '100%' }}
              className="receiveitembtn"
              onClick={() => {
                setModal('addModal')
                setSelectedItem(null)
              }}
              onKeyDown={(e) => navigation3(e, 'editExisting', 'LoadBtn', () => {})}
            >
              {tr('gsAddNew', '+ ADD NEW')}
            </Button>
          </Item>
        </Box>
      </Box>
      {tableData.length ? (
        <TableComponent
          reportName={reportName}
          criteriaHeaders={criteriaHeaders}
          criteriaData={[filterData]}
          tableData={tableData}
          mainHeader={headers}
          hideControls={true}
          manageColumnID={'ogplReportColumns'}
        />
      ) : null}
      {['addModal', 'editModal'].includes(modal) ? (
        <AddEditRouteModal
          item={selectedItem}
          idEdit={modal === 'editModal'}
          cityList={cityList}
          routeZones={translatedRouteZones.filter((zone) => zone.id)}
        />
      ) : null}
    </>
  )
}
